export const getUserFriendlyError = (error: unknown): string => {
  if (error instanceof Error) {
    const msg = error.message.toLowerCase();

    if (msg.includes("telegram webapp sdk"))
      return "Ошибка запуска через Telegram. Перезапустите приложение.";
    if (msg.includes("initdata"))
      return "Не удалось получить данные для запуска. Попробуйте снова.";
    if (msg.includes("прогноз ещё не готов"))
      return "Прогноз пока не готов. Пожалуйста, попробуйте позже.";
    if (msg.includes("не удалось получить натальную карту"))
      return "Не удалось загрузить натальную карту. Попробуйте ещё раз.";
    if (msg.includes("network") || msg.includes("failed to fetch"))
      return "Проблема с подключением. Проверьте интернет.";
    if (msg.includes("timeout")) return "Сервер долго не отвечает. Попробуйте позже.";
    if (msg.includes("500") || msg.includes("503"))
      return "Сервер временно недоступен. Мы уже работаем над этим.";
  }

  return "Что-то пошло не так. Попробуйте позже.";
};
